<!-- filter-condition-bar.component.html -->
<div class="main-container">
    <div class="wrapper filter-condition ym-display-flex ym-gap-2 ym-bg-t-gray-a-04 ym-p-3 ym-rounded-lg">
        <div class="content ym-display-flex ym-gap-2 ym-flex-wrap-wrap ym-w-full">
            <!-- Field Selection -->
            <app-field-selection-dropdown [label]="selectedField ? selectedField.label : 'Select field'"
                [canMultiSelect]="false" [allFields]="fieldDocuments" [allGroups]="fieldGroups"
                [selectedFields]="selectedField ? [selectedField.name] : []"
                (valueChange)="updateSelectedField($event)">
            </app-field-selection-dropdown>

            <!-- Operator Selection -->
            <div *ngIf="selectedField && operatorDropdownOptions.length > 0">
                <ym-dropdown class="operator-container" [showDropdown]="showOperatorDropdown"
                    [dropdownOption]="operatorDropdownOptions" [selectionType]="dropdownSelectionTypes.CHECKMARK"
                    (onDropdownClose)="toggleOperatorDropdown(false)" (selectedOption)="updateOperator($event)">
                    <ng-container trigger>
                        <ym-button [variant]="buttonVariants.DROPDOWN" (onClick)="toggleOperatorDropdown(true)">
                            {{ selectedOperator | textCase }}
                        </ym-button>
                    </ng-container>
                </ym-dropdown>
            </div>

            <!-- Value Input - Only show for operators that require values -->
            <div *ngIf="shouldShowValueInput()">
                <app-filter-condition-input [selectedFieldType]="selectedField!.field_type" [value]="currentValue"
                    [fieldDocuments]="fieldDocuments" [selectedField]="selectedField!.name" [allUsers]="allUsers"
                    (onUpdateValue)="updateValue($event)" (onInvalidationChange)="onInvalidationChange.emit($event)"
                    class="ym-w-full ym-max-w-26">
                </app-filter-condition-input>
            </div>
        </div>

        <!-- Remove Button -->
        <ym-button [type]="buttonTypes.GHOST" [icon]="iconNames.DELETE" [variant]="buttonVariants.ICON_ONLY"
            (onClick)="removeCondition()">
        </ym-button>
    </div>
</div>